import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const Swift = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  const handleDebouncedSwiftInputChange = useDebouncedCallback(() => trackInvoicingSettings('SWIFT/BIC typed'))

  return (
    <FormItem
      name="paymentMethods.swift"
      label={t('settings.organization.external_invoice.payment_methods.bank_transfer.default_swift.label')}
      render={({ field: { onChange, ...rest } }) => (
        <Input
          {...rest}
          onChange={(event) => {
            onChange(event)
            handleDebouncedSwiftInputChange()
          }}
        />
      )}
    />
  )
}
